import { combineReducers } from 'redux'
import breakdown from './breakdown.reducer'

export default combineReducers({
  breakdown
})
